import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { fetchPythonEndpoint } from 'react-query-config';

import { useAuth } from '../../context/Authentication.context';
import { ItemTypeWithCount } from '../../../@types/python.d';

export type FetchItemTypesResponse = ItemTypeWithCount[];

interface FetchItemTypesVariables {
	groupId: string;
	_fields?: string[];
}

interface PythonFetchItemTypesVariables {
	_fields?: string;
}

export const useFetchItemTypesQuery = <TData = FetchItemTypesResponse, TError = unknown>(
	variables: FetchItemTypesVariables,
	options?: UseQueryOptions<FetchItemTypesResponse, TError, TData>
) => {
	const authUser = useAuth();
	if (!authUser?.id) {
		throw new Error('User not authenticated');
	}

	return useQuery<FetchItemTypesResponse, TError, TData>(
		['itemTypes', variables],
		fetchPythonEndpoint<FetchItemTypesResponse, PythonFetchItemTypesVariables>(
			`${authUser.id}/null/jwt/groups/${variables.groupId}/call/getItemTypes`,
			variables._fields ? { _fields: variables._fields.join(',') } : {},
			'GET'
		),
		{
			...options,
		}
	);
};
